import { compose, branch, renderNothing, withProps, withPropsOnChange, withState } from 'recompose';

import { getDataTabNames } from './utils';
import ReportData from './ReportData';

export default compose(
  withState('activeTabIndex', 'selectTab', 0),
  withProps(props => ({
    tabNames: getDataTabNames(props.reportData, props.reportDefinition),
  })),
  withPropsOnChange(['reportData'], (props) => {
    props.selectTab(0);
  }),
  branch(props => !props.isReportDataFetched || !props.reportData.length, renderNothing)
)(ReportData);
